<template>
  <b-badge
    class="log-times-badge d-inline-flex"
    pill
    v-if="logTime"
  >
    <a
      @click.prevent="showLogTimesModal()"
      href="#"
      :class="{ 'disabled': !$can('update_all-log_times') }"
      title="Edit log time"
      v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
    >
      <span v-html="editIconSvg"></span>
    </a>
    <template v-if="logTime.external_link">
      <a :href="logTime.external_link ? logTime.external_link : null" target="_blank">
        <span class="material-symbols-outlined text-editor__block-icon has-comment">
          visibility
        </span>
      </a>
    </template>
    <a
      @click.prevent="deleteLogTime"
      :class="{ 'disabled': !$can('delete-log_times') }"
      href="#"
      title="Delete log time"
      v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
    >
      <span v-html="removeIconSvg"></span>
    </a>
    <LogTimeFormModal
      v-if="showForm"
      v-model="showForm"
      :dataProps="form"
      mode="edit"
      :isLoading="isLoading"
      :modal="true"
      :show-preloader="true"
      @submit="edit"
    />
  </b-badge>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapActions } from 'vuex'
import editIcon from '@/assets/icons/editIcon'
import removeIcon from '@/assets/icons/removeIcon'
import LogTimeFormModal from '../components/modals/LogTimeFormModal.vue'

export default {
  name: 'LogTimesLinks',
  components: {
    LogTimeFormModal
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      logTime: null,
      editIconSvg: editIcon({ size: 'lg' }),
      removeIconSvg: removeIcon({ size: 'lg' }),
      showForm: false,
      form: {},
      isLoading: false
    }
  },
  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler (item) {
        this.logTime = item
      }
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    edit (data) {
      this.isLoading = true
      const params = this.prepareDataForRequest(data)
      this.$api.logTimes.updateLogTime(this.logTime.id, params)
        .then(({ data, status }) => {
          this.$snotify.success(
            'Log time successfully saved',
            'Success',
            this.$store.state.snotify
          )

          this.form = {}
          this.hideLogTimesModal()
          this.logTime = cloneDeep(data)
          this.$emit('updatedLogTime', { data: this.logTime, status })
        })
        .catch(error => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    showLogTimesModal () {
      if (!this.$can('update_all-log_times')) {
        return
      }
      this.form = cloneDeep(this.logTime)
      this.showForm = true
    },
    hideLogTimesModal () {
      this.showForm = false
      this.form = {}
      this.setIsModalLoading(false)
    },
    async deleteLogTime () {
      if (!this.$can('delete-log_times')) {
        return false
      }
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the log time?'
      )
      if (!confirm) return
      this.setIsModalLoading(true)

      this.$api.logTimes.removeLogTime(this.logTime.id)
        .then(() => {
          this.$snotify.success(
            'Log time successfully deleted',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch(error => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.setIsModalLoading(false)
          this.$emit('deletedLogTime', { data: this.logTime.id })
        })
    },
    prepareDataForRequest (fields) {
      let newFields = cloneDeep(fields)
      let data = {}

      for (let key in newFields) {
        const field = newFields[key]
        const name = field['name']
        const value = field['value']
        if (!value) {
          continue
        }
        if (value) {
          data[name] = typeof value === 'object' ? value[field['valueField']] : value
        }
      }
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
.log-times-badge {
  gap: 5.5px;
  padding: 0;
  font-size: 14px;
  background-color: transparent;

  a {
    cursor: pointer;
    color: $fontColorAccent;
    margin-top: 1px;

    & .material-symbols-outlined {
      font-size: 20px;
    }
  }

  .edit {
    font-size: 18px;
    position: relative;
    bottom: 1px;
  }
}

.eye-icon, .delete-icon {
  position: relative;
  top: -2px;
  font-size: 20px;
}
</style>
